import React from 'react';
import PropTypes from 'prop-types';
import DateRangeIcon from '@material-ui/icons/DateRange';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import RoomOutlinedIcon from '@material-ui/icons/RoomOutlined';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import PeopleAltOutlinedIcon from '@material-ui/icons/PeopleAltOutlined';

import {
  BookingsContainer,
  H3,
  H4,
  BookingButton,
  ButtonsWrapper,
  BookingElement,
  BookingListElement,
  BookingListWrapper,
} from './styles';

const BookingsComponent = ({
  when, service, day, time, location, total, guests,
}) => (
  <BookingsContainer>
    <H4>{when}</H4>
    <H3>{service}</H3>
    <BookingListWrapper>
      <BookingElement>
        <DateRangeIcon />
        <BookingListElement>{day}</BookingListElement>
      </BookingElement>

      <BookingElement>
        <AccessTimeIcon />
        <BookingListElement>{time}</BookingListElement>
      </BookingElement>

      <BookingElement>
        <RoomOutlinedIcon />
        <BookingListElement>{location}</BookingListElement>
      </BookingElement>

      <BookingElement>
        <AttachMoneyIcon />
        <BookingListElement>{total}</BookingListElement>
      </BookingElement>

      <BookingElement>
        <PeopleAltOutlinedIcon />
        <BookingListElement>{`You + ${guests}`}</BookingListElement>
      </BookingElement>
    </BookingListWrapper>

    <ButtonsWrapper>
      <BookingButton>MODIFY</BookingButton>
      <BookingButton>CHECK-IN</BookingButton>
    </ButtonsWrapper>
  </BookingsContainer>
);

BookingsComponent.defaultProps = {
  when: '',
  service: '',
  day: 0,
  time: '',
  location: '',
  total: '',
  guests: '',
};

BookingsComponent.propTypes = {
  when: PropTypes.string,
  service: PropTypes.string,
  day: PropTypes.number,
  time: PropTypes.string,
  location: PropTypes.string,
  total: PropTypes.string,
  guests: PropTypes.string,
};

export default BookingsComponent;
